import {
  EligibilityStatus,
  ReceivableStatus
} from "../../../services/authService/AuthService.type";
import { localNumber } from "../../../helper/Format";

export const eligibilityCardContents = {
  labels: {
    eligibility: "Eligibility",
    status: "Status",
    bills: "Bills",
    myInfo: "My Info Card",
    eligibilityCardFoldMessage: (foldName: string) =>
      `Hey, right now you are at ${foldName}`,
    eligibilityCardDisabled:
      "You are few steps away to know your eligibility Loan amount, so get going",
    chartUtilized: "Utilized",
    chartResidue: "Residue",
    totalLoanAmount: (amount: number | null) =>
      `Total Loan Amount given Rs ${localNumber(amount, "0")}`,
    utilizeAmount: (amount: number | null) =>
      `Utilize Amount: Rs ${localNumber(amount, "0")}`,
    residueAmount: (amount: number | null) =>
      `Residue Amount: Rs ${localNumber(amount, "0")}`,
    totalResidueAmount: "Total Residue Amount: ",
    expiryDate: "Expiry Date: ",
    applicationClosed: "Your Loan Application has been closed."
  },
  buttons: {
    checkEligibility: "Check Eligibility"
  }
};

export const statusEligibilityFoldMapping = {
  [EligibilityStatus.CompanyDetailsFold]: "company details fold",
  [EligibilityStatus.ApplicantDetailsFold]: "applicant details fold",
  [EligibilityStatus.ReceivablesFold]: "receivable details fold",
  [EligibilityStatus.EligibilityAmountFold]: "eligibility amount fold",
  [EligibilityStatus.InsufficientGSTRData]: "eligibility amount fold",
  [EligibilityStatus.PrincipleAmountShared]: "eligibility amount fold",
  [EligibilityStatus.PrincipleAmountRejected]: "eligibility amount fold"
};

export const getEligibilityFoldName = (status: EligibilityStatus | null) => {
  if (!status) {
    return "";
  }
  return statusEligibilityFoldMapping[status] || "";
};

const statusButtonLabelMapping = {
  [EligibilityStatus.PrincipleAmountAccepted]: "Upload Account Details",
  [EligibilityStatus.DocumentUploadPending]: "Upload Documents"
};

export const getButtonLabel = (
  status: EligibilityStatus | null,
  inEligibilityFolds: boolean
) => {
  if (!status) {
    return "";
  }
  if (inEligibilityFolds) {
    return eligibilityCardContents.buttons.checkEligibility;
  }
  return (
    statusButtonLabelMapping[status] ||
    eligibilityCardContents.buttons.checkEligibility
  );
};

const statusMessageMapping = (eligibilityAmount: string) => ({
  [EligibilityStatus.AwaitingPrincipleAmount]: `Thanks for uploading GSTR files, we are evaluating your documents and will update you on your eligible loan amount shortly.`,
  [EligibilityStatus.PrincipleAmountAccepted]: `You have accepted the eligibility loan amount of 
  Rs ${eligibilityAmount}..\nPlease provide your current account details for verification.`,
  [EligibilityStatus.OpportunityLost]: `You have rejected the Rs ${eligibilityAmount} offered.`,
  [EligibilityStatus.PrincipleAmountRejected]: `You have rejected the Rs ${eligibilityAmount} 
  offered.`,
  [EligibilityStatus.DocumentUploadPending]: `You have accepted the eligibility loan amount of 
  Rs ${eligibilityAmount} and uploaded your Account Details..\n Please upload your proof 
  documents to enable us to start verifying your Application.`,
  [EligibilityStatus.ApplicationVerificationInProgress]: `You have accepted the eligibility loan
   amount of Rs ${eligibilityAmount}, and uploaded your Account details and documents..\n Your 
   Application verification is currently in progress.`,
  [EligibilityStatus.DMIInitiated]: `You have accepted the eligibility loan
   amount of Rs ${eligibilityAmount}, and uploaded your Account details and documents..\n Your 
   Application verification is currently in progress.`,
  [EligibilityStatus.ReadyForConversion]: `Your eligibility loan amount of Rs ${eligibilityAmount}
    has been approved and is ready for conversion.`
});

export const getStatusMessage = (
  status: EligibilityStatus | null,
  eligibilityAmount: number | null,
  receivableStatus: ReceivableStatus | null
) => {
  if (!status) {
    return "";
  } else if (receivableStatus === ReceivableStatus.AwaitingAcceptance) {
    return `Your eligibility amount has been updated to 
    Rs ${eligibilityAmount}..\nKindly accept to proceed further.`;
  }
  return statusMessageMapping(localNumber(eligibilityAmount))[status] || "";
};
